export enum ScenarioStage {
  None = "None",
  Intro = "Intro",
  InputWait = "InputWait",
  Movement = "Movement",
  Ended = "Ended",
}
